import ahmad from "../../../asset/about-us/ahmad.webp";
import salman from "../../../asset/about-us/salman.webp";
import StatsComponent from "./StatsComponent";
import AboutTeamImages from "./ImagesSection";

const AboutTeam = () => {
  return (
    <section className="container mx-auto flex flex-col xl:flex-row">
      <div className="mb-[73px] md:mb-[91px] xl:mb-0">
        <div className=" text-center xl:text-start space-y-7 ">
          <h4 className="font-bold  text-light text-xs ">About Our Team</h4>

          <h2 className="  md:text-[36px] text-2xl font-semibold md:leading-[51px] xl:max-w-[704px]">
            We’re a Sydney-based AI innovation team dedicated to building
            intelligent systems that transform businesses.
          </h2>
        </div>

        <div className="hidden xl:block">
          <div className="space-y-4">
            <div className=" mt-[221px] flex -space-x-6">
              <div
                style={{
                  background:
                    "linear-gradient(90deg, rgba(247, 247, 245, 0.2) 0%, rgba(17, 24, 39, 0.2) 53%, rgba(247, 247, 245, 0.2) 100%)",
                }}
                className="rounded-full w-[112px] h-[112px] overflow-hidden"
              >
                <img
                  width={112}
                  height={112}
                  className="rounded-full scale-[97%] bg-white"
                  src={salman}
                  alt={"salman"}
                />
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(90deg, rgba(247, 247, 245, 0.2) 0%, rgba(17, 24, 39, 0.2) 53%, rgba(247, 247, 245, 0.2) 100%)",
                }}
                className="rounded-full w-[112px] h-[112px] overflow-hidden required:z-10"
              >
                <img
                  width={112}
                  height={112}
                  className="rounded-full scale-[97%] bg-white"
                  src={ahmad}
                  alt={"ahmad"}
                />
              </div>
            </div>
            <p className="text-[#888888] text-sm font-semibold">
              Founders of Raadco
            </p>
          </div>
          <div className="flex gap-4 mt-[110px]">
            <StatsComponent
              percentage={100}
              description="Client Satisfaction"
            />
            <StatsComponent
              percentage={90}
              description="Projects completed in Australia"
            />
          </div>
        </div>
      </div>
      <AboutTeamImages />

      <div className="flex text-center xl:mt-0 md:mt-16 mt-6 flex-col items-center xl:hidden">
        <div className="space-y-4">
          <div className="  flex -space-x-6">
            <div
              style={{
                background:
                  "linear-gradient(90deg, rgba(247, 247, 245, 0.2) 0%, rgba(17, 24, 39, 0.2) 53%, rgba(247, 247, 245, 0.2) 100%)",
              }}
              className="rounded-full w-[112px] h-[112px] overflow-hidden"
            >
              <img
                width={112}
                height={112}
                className="rounded-full scale-[97%] bg-white"
                src={salman}
                alt={"salman"}
              />
            </div>
            <div
              style={{
                background:
                  "linear-gradient(90deg, rgba(247, 247, 245, 0.2) 0%, rgba(17, 24, 39, 0.2) 53%, rgba(247, 247, 245, 0.2) 100%)",
              }}
              className="rounded-full w-[112px] h-[112px] overflow-hidden required:z-10"
            >
              <img
                width={112}
                height={112}
                className="rounded-full scale-[97%] bg-white"
                src={ahmad}
                alt={"ahmad"}
              />
            </div>
          </div>
          <p className="text-[#888888] text-sm font-semibold">
            Founders of Raadco
          </p>
        </div>
        <div className="flex gap-4 mt-8">
          <StatsComponent percentage={100} description="Client Satisfaction" />
          <StatsComponent
            percentage={90}
            description="Projects completed in Australia"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutTeam;
